const singleForms = ($form) => {
  let $button = $form.querySelector('button[type="submit"]'),
      $select = $form.querySelector('select')
  $button.addEventListener('click', (e) => {
    e.preventDefault()
    // --
    if($select && $select.value == 'all')
      $select.value = ''
    $form.submit()
  })
}

const searchForm = () => {
  let $forms = document.querySelectorAll('.search-sections-form')

  if($forms.length == 0) return

  $forms.forEach(($form) => {
    singleForms($form)
  })
}
export default searchForm
